import { Skeleton } from 'antd';

const AppShellSkeleton: React.FC = () => {
  return (
    <div style={{ padding: 24, background: '#f0f2f5', minHeight: '100%' }}>
      {/* Page title */}
      <Skeleton.Input active style={{ width: 220, height: 28, marginBottom: 24, display: 'block' }} size="default" />

      {/* Stats cards row */}
      <div style={{ display: 'flex', gap: 16, marginBottom: 24 }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              background: '#fff',
              borderRadius: 8,
              padding: 20,
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            }}
          >
            <Skeleton active paragraph={{ rows: 2 }} title={{ width: '60%' }} />
          </div>
        ))}
      </div>

      {/* Content panels */}
      <div style={{ display: 'flex', gap: 16 }}>
        <div
          style={{
            flex: 2,
            background: '#fff',
            borderRadius: 8,
            padding: 20,
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
        >
          <Skeleton active paragraph={{ rows: 6 }} />
        </div>
        <div
          style={{
            flex: 1,
            background: '#fff',
            borderRadius: 8,
            padding: 20,
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}
        >
          <Skeleton active paragraph={{ rows: 6 }} />
        </div>
      </div>
    </div>
  );
};

export default AppShellSkeleton;
